import api from './api';
import { Nas, NasFormData, NasFilters, NasConnectionTest, NasStats, NasActiveClientsResponse } from '../types';

export const nasService = {
  // Listar todos os NAS
  async getAll(filters?: NasFilters): Promise<Nas[]> {
    const params = new URLSearchParams();

    if (filters?.search) {
      params.append('search', filters.search);
    }
    if (filters?.type) {
      params.append('type', filters.type);
    }

    const response = await api.get(`/nas?${params}`) as any;
    return response;
  },

  // Buscar NAS por ID
  async getById(id: number): Promise<Nas> {
    const response = await api.get(`/nas/${id}`) as any;
    return response;
  },

  // Criar novo NAS
  async create(data: NasFormData): Promise<Nas> {
    const response = await api.post('/nas', data) as any;
    return response.nas;
  },

  // Atualizar NAS
  async update(id: number, data: Partial<NasFormData>): Promise<Nas> {
    const response = await api.put(`/nas/${id}`, data) as any;
    return response.nas;
  },

  // Deletar NAS
  async delete(id: number): Promise<void> {
    await api.delete(`/nas/${id}`);
  },

  // Testar conectividade com NAS (timeout 12s - backend responde em até 10s)
  async testConnection(id: number): Promise<NasConnectionTest> {
    const response = await api.post(`/nas/${id}/test`, {}, {
      timeout: 12000
    }) as any;
    return response;
  },

  // Sincronizar com MikroTik
  async sync(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/nas/${id}/sync`) as any;
    return response;
  },

  // Buscar por tipo
  async getByType(type: string): Promise<Nas[]> {
    const response = await api.get(`/nas?type=${type}`) as any;
    return response;
  },

  // Obter estatísticas
  async getStatistics(): Promise<NasStats> {
    const response = await api.get('/nas/stats') as any;
    return response;
  },

  // Gerar secret aleatório
  async generateSecret(length: number = 16): Promise<string> {
    const response = await api.post('/nas/generate-secret', { length }) as any;
    return response.secret;
  },

  // Validar nasname (IP/hostname)
  async validateNasname(nasname: string): Promise<boolean> {
    const response = await api.post('/nas/validate-nasname', { nasname }) as any;
    return response.valid;
  },

  // Bulk import
  async bulkImport(nasList: NasFormData[]): Promise<{
    created: Nas[];
    errors: { nas: NasFormData; error: string }[];
  }> {
    const response = await api.post('/nas/bulk-import', { nasList }) as any;
    return response;
  },

  // Buscar clientes online (conexões PPP ativas)
  async getActiveClients(id: number): Promise<NasActiveClientsResponse> {
    const response = await api.get(`/nas/${id}/active-clients`) as any;
    return response;
  },

  // Obter status do radius
  async getRadiusStatus(): Promise<{ status: string; log: string }> {
    const response = await api.get('/nas/radius-status') as any;
    return response;
  },

  // Reiniciar serviço do radius
  async restartRadius(): Promise<{ message: string }> {
    const response = await api.post('/nas/radius-restart') as any;
    return response;
  }
}; 